import { combineReducers } from 'redux-immutable';
import { combineEpics } from 'redux-observable';
import { reducer as formReducer } from 'redux-form/immutable';

import user from 'modules/user/reducer';
import userEpics from 'modules/user/epics';
import viajes from 'modules/viajes/reducer';
import viajesEpics from 'modules/viajes/epics';
import rutinas from 'modules/rutinas/reducer';
import rutinasEpics from 'modules/rutinas/epics';
import vehiculos from 'modules/vehiculos/reducer';
import vehiculosEpics from 'modules/vehiculos/epics';
import dispositivos from 'modules/dispositivos/reducer';
import dispositivosEpics from 'modules/dispositivos/epics';
import abonados from 'modules/abonados/reducer';
import abonadosEpics from 'modules/abonados/epics';
import reservas from 'modules/reservas/reducer';
import reservasEpics from 'modules/reservas/epics';
import feriados from 'modules/feriados/reducer';
import feriadosEpics from 'modules/feriados/epics';
import paradas from 'modules/paradas/reducer';
import paradasEpics from 'modules/paradas/epics';
import general from 'modules/general/reducer';
import generalEpics from 'modules/general/epics';
import usuariosCasuales from 'modules/usuariosCasuales/reducer';
import usuariosCasualesEpics from 'modules/usuariosCasuales/epics';
import registros from 'modules/registros/reducer';
import registrosEpics from 'modules/registros/epics';
import roles from 'modules/roles/reducer';
import rolesEpic from 'modules/roles/epics';
import asignaciones from 'modules/asignacion/reducer';
import asignacionesEpic from 'modules/asignacion/epics';
import mapaGeneral from 'modules/mapaGeneral/reducer';
import mensajes from 'modules/mensajes/reducer';
import mensajesEpic from 'modules/mensajes/epics';
import trayectos from 'modules/trayectos/reducer';
import trayectosEpic from 'modules/trayectos/epics';
import reportes from 'modules/reportes/reducer';
import reportesEpic from 'modules/reportes/epics';
import grupos from 'modules/grupos/reducer';
import gruposEpic from 'modules/grupos/epics';
import gruposSolicitudes from 'modules/gruposSolicitudes/reducer';
import gruposSolicitudesEpic from 'modules/gruposSolicitudes/epics';
import precios from 'modules/precios/reducer';
import preciosEpics from 'modules/precios/epics';
import penalizaciones from 'modules/penalizaciones/reducer';
import penalizacionesEpics from 'modules/penalizaciones/epics';

import immutableRouter from 'core/immutableRouter';

export const combinedReducers = combineReducers({
  user,
  viajes,
  rutinas,
  vehiculos,
  dispositivos,
  abonados,
  reservas,
  general,
  feriados,
  paradas,
  usuariosCasuales,
  registros,
  roles,
  mapaGeneral,
  asignaciones,
  routing: immutableRouter,
  form: formReducer,
  mensajes,
  trayectos,
  reportes,
  grupos,
  gruposSolicitudes,
  precios,
  penalizaciones,
});

export const combinedEpics = (action$, store) =>
  combineEpics(
    userEpics,
    viajesEpics,
    rutinasEpics,
    vehiculosEpics,
    dispositivosEpics,
    abonadosEpics,
    reservasEpics,
    generalEpics,
    feriadosEpics,
    paradasEpics,
    usuariosCasualesEpics,
    registrosEpics,
    rolesEpic,
    asignacionesEpic,
    mensajesEpic,
    trayectosEpic,
    reportesEpic,
    gruposEpic,
    gruposSolicitudesEpic,
    preciosEpics,
    penalizacionesEpics,
  )(action$, store);



// WEBPACK FOOTER //
// src/core/reducersAndEpics.js